module.exports = __webpack_public_path__ + "static/media/miku-narrow.c3aa745f.png";